import { Link } from "react-router-dom";

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20Korean%20manhwa%20illustration%20with%20warm%20gradient%20colors%20of%20coral%20and%20gold%2C%20abstract%20comic%20panel%20layout%20design%2C%20soft%20dreamy%20atmosphere%20with%20floating%20sparkles%2C%20minimalist%20Korean%20aesthetic%2C%20clean%20digital%20art%20style&width=1920&height=800&seq=hero-bg-01&orientation=landscape"
        alt="韩漫在线 - 免费韩国漫画阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <h1 className="font-heading text-4xl md:text-6xl font-bold text-background-50 leading-tight mb-4">
                探索韩国漫画的
                <br />
                <span className="text-accent-400">无限精彩</span>
              </h1>
              <p className="text-base md:text-lg text-background-200/90 mb-8 leading-relaxed max-w-xl">
                韩漫在线为您提供海量优质韩国漫画免费在线阅读。涵盖恋爱、奇幻、动作、悬疑等丰富分类，每日更新，让您随时随地畅享精彩故事。
              </p>
              <div className="flex flex-col sm:flex-row items-start gap-3">
                <Link
                  to="/category/all"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
                >
                  开始阅读
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
                <Link
                  to="/category/romance"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full border border-background-50/30 hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
                >
                  热门恋爱
                  <i className="ri-heart-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        <div className="w-8 h-1 bg-background-50/60 rounded-full"></div>
        <div className="w-3 h-1 bg-background-50/30 rounded-full"></div>
        <div className="w-3 h-1 bg-background-50/30 rounded-full"></div>
      </div>
    </section>
  );
}